import { Box, Typography, useTheme, useMediaQuery, styled } from '@mui/material';
import React from 'react';

const EventItem = styled(Box)(({ theme }) => ({
  background: '#fff',
  borderRadius: theme.shape.borderRadius,
  position: "relative",
  overflow: "hidden",
  boxShadow: '0 0 20px 5px #0000000D',
  transition: "transform 0.3s ease, box-shadow 0.3s ease",
  minHeight: "40px",
  height: '40px',
  display: 'flex',
  alignItems: 'center',
  width:5,
  justifyContent: 'center',
  [theme.breakpoints.down('sm')]: {
    minHeight: "40px",
  },
  "&:hover": {
    transform: "translateY(-5px)",
    boxShadow: theme.shadows[3],
  },
}));

function EventBody(event) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));

  const getDateDifference = (startDate) => {
    const currentDate = new Date();
    const eventStartDate = new Date(startDate);
    const differenceInTime = eventStartDate - currentDate;
    return Math.ceil(differenceInTime / (1000 * 3600 * 24));
  };

  const getTitleColor = (days) => {
    if (days > 7) return "#34A853";
    if (days > 3) return "#FFA800";
    return "#FF0000";
  };

  const differenceInDays = getDateDifference(event.start);
  const titleColor = getTitleColor(differenceInDays);
  const myEvent = event.event._def;

  return (
    <EventItem
      sx={{
        width: {
          xs: '10px',
          sm: '50px',
          md: '100px'
        },
        margin: {
          xs: '0 auto',
          sm: '0 auto',
          md: '0'
        },
        cursor: "pointer"
      }}
    >
      <Typography
        sx={{
          fontSize: {
            xs: 6,
            sm: 11,
            md: 12
          },
          fontFamily: "Poppins",
          textTransform: "none",
          color: titleColor,
          fontWeight: 500,
          textAlign: "center",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          width: "100%",
          paddingX: 1,
          display: 'block'
        }}
      >
        {myEvent.title}
      </Typography> 
    </EventItem>
  );
}

export default EventBody;